import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable,  of,  pipe } from 'rxjs';
import { SharedDataService ,ContactsService } from '../all-services';
import {  IntUser,IntUserStatutHistory,IntUserUpdateParameters,PS_Lst_IntUsers_Result, SimpleReponseResult} from '../all-models';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IntUsersService  {
  intUsersUrl: string

  constructor(public sharedDataSvc:SharedDataService, private http: HttpClient,private contactsSvc: ContactsService) {
    this.intUsersUrl = this.sharedDataSvc.apiBaseUrl + 'IntUsers';
   }

  public IntUsers():Observable<IntUser[]> {
    return this.http.get<IntUser[]>(`${this.intUsersUrl}`)
    .pipe(map((intUsers:IntUser[])=>{
      intUsers.forEach(u=>{
        u.Contact && (u.Contact.Civility= this.sharedDataSvc.civilities?.find(c=>c.Id==u.Contact.CivId));
      })
      return intUsers;
    }));
  }

  public RetrieveByUid(uid : string): Observable<IntUser> {    
    let intUser:IntUser=new IntUser();
    intUser.UtiGid = uid;
    return this.http.post<IntUser>(`${this.intUsersUrl}RetrieveByUid`,intUser);
  }

  public PS_Lst_IntUsers():Observable<PS_Lst_IntUsers_Result[]> {
    return this.http.get<PS_Lst_IntUsers_Result[]>(`${this.intUsersUrl}/PS_Lst_IntUsers`);

  }

  public IntUser(id:Number):Observable<IntUser> {
    return this.http.get<IntUser>(`${this.intUsersUrl}/${id}`);
  }

  public add(intUser:IntUser ):Observable<IntUser> {
    return this.http.post<IntUser>(`${this.intUsersUrl}/Add`,intUser);
  }

  public update(id:Number, parameters: IntUserUpdateParameters ):Observable<IntUser> {
    return this.http.post<IntUser>(`${this.intUsersUrl}/${id}/Update`,parameters);
  }
  
  public changeStatut(intUserId:number, intUserStatutId : number,comments:string):Observable<IntUser> {
    return this.IntUser(intUserId)
    .pipe(
      switchMap((intUser:IntUser)=>{
        let param:IntUserUpdateParameters = new IntUserUpdateParameters();
        param.StatutOnly = true;
        param.IntUser=intUser;
        param.Etbs=[];
        param.IntUserStatutHistory = new IntUserStatutHistory();
        param.IntUserStatutHistory.Comments = comments;
        param.IntUserStatutHistory.IntUserId = intUser.Id;
        param.IntUserStatutHistory.StatutId = intUserStatutId;
        return this.update(param.IntUser.Id,param);
      })
    );    
  }

  public canDelete(intUserId:number):Observable<SimpleReponseResult>{
    return this.http.get<SimpleReponseResult>(`${this.intUsersUrl}/${intUserId}/CanDelete`);
  }
  
  public delete(intUserId:number):Observable<SimpleReponseResult>{
    return this.http.delete<SimpleReponseResult>(`${this.intUsersUrl}/${intUserId}/Delete`)
   }

   public isLocked(intUserId:number):Observable<boolean>{
    return this.http.get<boolean>(`${this.intUsersUrl}/${intUserId}/IsLocked`)
   }


  
}